import React from 'react'

import InitialLoginModal from '../projects/components/InitialLoginModal'
import AuthenticationComponent from '../../AuthenticationComponent'

import landingPageBG from '../../static/images/ptor-landing-page-bg.jpg'
import './style.css'


const LandingPage = () => {
    const pageStyle = {
        backgroundImage: `url(${landingPageBG})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    }

    // const pageBody = document.querySelector('body')
    // pageBody.style.backgroundImage = `url(${landingPageBG})`

    return (
        <div id="LandingPage" style={pageStyle}>
            <AuthenticationComponent />
            <InitialLoginModal />

            <h1>Welcome to PTOR, the gateway to GRG toolset.</h1>
        </div>
    )
}

export default LandingPage


// WEBPACK FOOTER //
// ./src/routes/landing-page/LandingPage.js